import { Phone, MessageCircle, Mail, MessageSquare, MapPin, Bell } from "lucide-react"

// Outreach channels — keep in sync with Task::FOLLOW_UP_CHANNELS (server).
export const FOLLOW_UP_CHANNELS = [
  { value: "call", label: "Call", Icon: Phone, cls: "bg-blue-50 text-blue-700" },
  { value: "whatsapp", label: "WhatsApp", Icon: MessageCircle, cls: "bg-green-50 text-green-700" },
  { value: "email", label: "Email", Icon: Mail, cls: "bg-violet-50 text-violet-700" },
  { value: "sms", label: "SMS", Icon: MessageSquare, cls: "bg-amber-50 text-amber-700" },
  { value: "site_visit", label: "Site visit", Icon: MapPin, cls: "bg-indigo-50 text-indigo-700" },
  { value: "other", label: "Other", Icon: Bell, cls: "bg-slate-100 text-slate-600" },
]

export const CHANNEL_BY_VALUE = Object.fromEntries(FOLLOW_UP_CHANNELS.map((c) => [c.value, c]))

// Outcomes logged when a follow-up is completed — keep in sync with
// Task::FOLLOW_UP_OUTCOMES (server).
export const FOLLOW_UP_OUTCOMES = [
  { value: "connected", label: "Connected", cls: "bg-green-100 text-green-700" },
  { value: "no_answer", label: "No answer", cls: "bg-amber-100 text-amber-700" },
  { value: "busy", label: "Busy", cls: "bg-orange-100 text-orange-700" },
  { value: "not_interested", label: "Not interested", cls: "bg-red-100 text-red-700" },
  { value: "reschedule", label: "Reschedule", cls: "bg-blue-100 text-blue-700" },
  { value: "converted", label: "Converted", cls: "bg-emerald-100 text-emerald-700" },
]

export const OUTCOME_BY_VALUE = Object.fromEntries(FOLLOW_UP_OUTCOMES.map((o) => [o.value, o]))
